/**
 * Utilitaire pour gérer les erreurs d'API de manière robuste
 */

/**
 * Convertit une erreur d'API en message lisible
 * @param {any} errorData - Données d'erreur de l'API
 * @param {string} defaultMessage - Message par défaut si l'erreur n'est pas lisible
 * @returns {string} Message d'erreur lisible
 */
export const formatErrorMessage = (errorData, defaultMessage = 'Erreur inconnue') => {
  // Si c'est déjà une string, la retourner
  if (typeof errorData === 'string') {
    return errorData;
  }

  // Si l'errorData a une propriété detail
  if (errorData && errorData.detail) {
    // Si detail est une string
    if (typeof errorData.detail === 'string') {
      return errorData.detail;
    }
    
    // Si detail est un array (erreurs de validation Pydantic)
    if (Array.isArray(errorData.detail)) {
      return errorData.detail
        .map(err => err.msg || err.message || 'Erreur de validation')
        .join(', ');
    }
    
    // Si detail est un objet complexe
    if (typeof errorData.detail === 'object') {
      return errorData.detail.msg || errorData.detail.message || defaultMessage;
    }
  }

  // Si l'errorData a une propriété message
  if (errorData && errorData.message) {
    return errorData.message;
  }

  // Retourner le message par défaut
  return defaultMessage;
};

/**
 * Gère une erreur d'API et retourne un message formaté
 * @param {Response} response - Réponse HTTP
 * @param {string} defaultMessage - Message par défaut
 * @returns {Promise<string>} Message d'erreur formaté
 */
export const handleApiError = async (response, defaultMessage = 'Erreur inconnue') => {
  try {
    const errorData = await response.json();
    return formatErrorMessage(errorData, defaultMessage);
  } catch {
    // Si impossible de parser le JSON, retourner le message par défaut
    return defaultMessage;
  }
};